module.exports = __webpack_public_path__ + "img/videocover.a1ba18ea.png";